import SvgColor from "../../../components/SvgColor";
import { App, Access, Role } from "../../../models";
import { hasSalesDashboardAccess } from "../../../pages/salesDashboard/lib";

const icon = (name: any) => (
  <SvgColor src={`/assets/icons/navbar/${name}`} sx={{ width: 1, height: 1 }} />
);

const getNavConfig = (
  t: any,
  app: string,
  role: string,
  isBranch: boolean,
  access: Array<string>,
  isFoodBusiness: boolean,
) => {
  if (app === App.APP) {
    return [
      {
        title: t("Dashboard"),
        path: "/dashboard",
        icon: icon("ic_analytics.svg"),
      },
    ];
  }
  let navConfig: Array<any> = isBranch
    ? [
        {
          title: t("Dashboard"),
          path: "/dashboard",
          icon: icon("ic_analytics.svg"),
        },
        ...(access.includes(Access.ACCOUNT) &&
        (role === Role.SUPERADMIN ||
          role === Role.ADMIN ||
          role === Role.MANAGER)
          ? [
              {
                title: t("Account"),
                path: "/account",
                icon: icon("account.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.STORE)
          ? [
              {
                title: t("Store"),
                path: "/store",
                icon: icon("store.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.CATEGORY)
          ? [
              {
                title: t("Category"),
                path: "/category",
                icon: icon("icons8-category-58.png"),
              },
            ]
          : []),
        ...(access.includes(Access.PRODUCT)
          ? [
              {
                title: t("Product"),
                path: "/product",
                icon: icon("product.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.PRODUCTION_COSTING) &&
        (role === Role.SUPERADMIN ||
          role === Role.ADMIN ||
          role === Role.MANAGER)
          ? [
              {
                title: t(
                  isFoodBusiness
                    ? "Costing.Food.Title"
                    : "Costing.Production.Title",
                ),
                path: "/recipe-costing",
                icon: icon("recipe-costing.svg"),
              },
              {
                title: t(
                  isFoodBusiness
                    ? "FoodCost.Food.Title"
                    : "FoodCost.Production.Title",
                ),
                path: "/food-cost",
                icon: icon("food-cost.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.DELIVERY_APP_PRICING) &&
        (role === Role.SUPERADMIN ||
          role === Role.ADMIN ||
          role === Role.MANAGER)
          ? [
              {
                title: t("Delivery.Title"),
                path: "/delivery-pricing",
                icon: icon("delivery-pricing.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.PURCHASE)
          ? [
              {
                title: t("Purchase"),
                path: "/purchase",
                icon: icon("shopping-bag-3-line.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.SALE)
          ? [
              {
                title: t("Sale"),
                path: "/sale",
                icon: icon("shopping-cart.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.ORDER)
          ? [
              {
                title: t("Order"),
                path: "/order",
                icon: icon("shopping-cart-solid-badged.svg"),
              },
            ]
          : []),
        ...(hasSalesDashboardAccess(access)
          ? [
              {
                title: t("SalesDashboard"),
                path: "/sales-dashboard",
                icon: icon("sales-dashboard.svg"),
              },
              {
                title: t("CashierShifts"),
                path: "/cashier-shift",
                icon: icon("cashier-shift.svg"),
              },
              {
                title: t("Counters"),
                path: "/counter",
                icon: icon("counter.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.INVOICE)
          ? [
              {
                title: t("Invoice"),
                path: "/invoice",
                icon: icon("invoice.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.RESTAURANT)
          ? [
              {
                title: t("Restaurant"),
                path: "/restaurant",
                icon: icon("restaurant.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.QUOTATION)
          ? [
              {
                title: t("Quotation"),
                path: "/quotation",
                icon: icon("quotation.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.SUPPLIER)
          ? [
              {
                title: t("Supplier"),
                path: "/supplier",
                icon: icon("user-check.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.CUSTOMER)
          ? [
              {
                title: t("Customer"),
                path: "/customer",
                icon: icon("baseline-group.svg"),
              },
            ]
          : []),
        ...(role === Role.SUPERADMIN ||
        role === Role.ADMIN ||
        role === Role.MANAGER
          ? [
              ...(access.includes(Access.TRANSFER)
                ? [
                    {
                      title: t("Transfer"),
                      path: "/transfer",
                      icon: icon("icons8-data-transfer-50.png"),
                    },
                  ]
                : []),
              ...(access.includes(Access.STOCK)
                ? [
                    {
                      title: t("Stock"),
                      path: "/stock",
                      icon: icon("icons8-stocks-50.png"),
                    },
                  ]
                : []),
              ...(access.includes(Access.STOCK_COUNTS) &&
              (role === Role.SUPERADMIN ||
                role === Role.ADMIN ||
                role === Role.MANAGER)
                ? [
                    {
                      title: t("StockCount.Title"),
                      path: "/stock-count",
                      icon: icon("stock-count.svg"),
                    },
                  ]
                : []),
            ]
          : []),
        ...(access.includes(Access.WASTAGE)
          ? [
              {
                title: t("Wastage"),
                path: "/wastage",
                icon: icon("waste-basket.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.USAGE)
          ? [
              {
                title: t("Usage"),
                path: "/usage",
                icon: icon("usage.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.VOUCHER)
          ? [
              {
                title: t("Voucher"),
                path: "/voucher",
                icon: icon("voucher.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.EXPENSE) || access.includes(Access.INCOME)
          ? [
              {
                title: t("IECategory"),
                path: "/ie-category",
                icon: icon("ieflow.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.EXPENSE)
          ? [
              {
                title: t("Expenses"),
                path: "/expense",
                icon: icon("expense.png"),
              },
            ]
          : []),
        ...(access.includes(Access.INCOME)
          ? [
              {
                title: t("Income"),
                path: "/income",
                icon: icon("income.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.FINANCE)
          ? [
              {
                title: t("Finance"),
                path: "/finance",
                icon: icon("finance.svg"),
              },
            ]
          : []),
      ]
    : [
        {
          title: t("Dashboard"),
          path: "/dashboard",
          icon: icon("ic_analytics.svg"),
        },
        ...(access.includes(Access.STORE)
          ? [
              {
                title: t("Store"),
                path: "/store",
                icon: icon("store.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.CATEGORY)
          ? [
              {
                title: t("Category"),
                path: "/category",
                icon: icon("icons8-category-58.png"),
              },
            ]
          : []),
        ...(access.includes(Access.PRODUCT)
          ? [
              {
                title: t("Product"),
                path: "/product",
                icon: icon("product.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.PRODUCTION_COSTING) &&
        (role === Role.SUPERADMIN ||
          role === Role.ADMIN ||
          role === Role.MANAGER)
          ? [
              {
                title: t(
                  isFoodBusiness
                    ? "Costing.Food.Title"
                    : "Costing.Production.Title",
                ),
                path: "/recipe-costing",
                icon: icon("recipe-costing.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.DELIVERY_APP_PRICING) &&
        (role === Role.SUPERADMIN ||
          role === Role.ADMIN ||
          role === Role.MANAGER)
          ? [
              {
                title: t("Delivery.Title"),
                path: "/delivery-pricing",
                icon: icon("delivery-pricing.svg"),
              },
            ]
          : []),

        // ...(access.includes(Access.PURCHASE)
        //   ? [
        //       {
        //         title: t("Purchase"),
        //         path: "/purchase",
        //         icon: icon("shopping-bag-3-line.svg"),
        //       },
        //     ]
        //   : []),

        ...(access.includes(Access.SUPPLIER)
          ? [
              {
                title: t("Supplier"),
                path: "/supplier",
                icon: icon("user-check.svg"),
              },
            ]
          : []),
        ...(access.includes(Access.CUSTOMER)
          ? [
              {
                title: t("Customer"),
                path: "/customer",
                icon: icon("baseline-group.svg"),
              },
            ]
          : []),
        ...(role === Role.SUPERADMIN ||
        role === Role.ADMIN ||
        role === Role.MANAGER
          ? [
              ...(access.includes(Access.TRANSFER)
                ? [
                    {
                      title: t("Transfer"),
                      path: "/transfer",
                      icon: icon("icons8-data-transfer-50.png"),
                    },
                  ]
                : []),
              ...(access.includes(Access.STOCK)
                ? [
                    {
                      title: t("Stock"),
                      path: "/stock",
                      icon: icon("icons8-stocks-50.png"),
                    },
                  ]
                : []),
            ]
          : []),
      ];

  // if (access.includes(Access.EXPENSE)) {
  //   navConfig.push({
  //     title: t("Expenses"),
  //     path: "/expense",
  //     icon: icon("expense.png"),
  //   });
  // }

  // if (isBranch && access.includes(Access.FINANCE)) {
  //   navConfig.push({
  //     title: t("Finance"),
  //     path: "/finance",
  //     icon: icon("finance.svg"),
  //   });
  // }

  if (
    access.includes(Access.ACCOUNTS) &&
    (role === Role.SUPERADMIN || role === Role.ADMIN || role === Role.MANAGER)
  ) {
    navConfig.push({
      title: t("Accounts"),
      path: "/accounts",
      icon: icon("accounts.png"),
    });
  }

  if (
    access.includes(Access.BRANCH) &&
    !isBranch &&
    (role === Role.SUPERADMIN ||
      role === Role.ADMIN ||
      role === Role.MANAGER ||
      role === Role.SUPERVISOR)
  ) {
    navConfig.push({
      title: t("Branch"),
      path: "/branch",
      icon: icon("branch.svg"),
    });
  }

  if (
    access.includes(Access.USER) &&
    (role === Role.SUPERADMIN ||
      role === Role.ADMIN ||
      role === Role.MANAGER ||
      role === Role.SUPERVISOR)
  ) {
    navConfig.push({
      title: t("Employee"),
      path: "/user",
      icon: icon("ic_user.svg"),
    });
  }

  if (
    access.includes(Access.FEEDBACK) &&
    isBranch &&
    (role === Role.SUPERADMIN || role === Role.ADMIN || role === Role.MANAGER)
  ) {
    navConfig.push({
      title: t("Feedback"),
      path: "/feedbacks",
      icon: icon("ic_feedback.svg"),
    });
  }

  if (
    isBranch &&
    access.includes(Access.CRM) &&
    (role === Role.SUPERADMIN || role === Role.ADMIN || role === Role.MANAGER)
  ) {
    navConfig.push({
      title: t("WhatsAppMarketing"),
      path: "/whatsapp-marketing",
      icon: icon("whatsapp.svg"),
    });

    navConfig.push({
      title: t("EmailMarketing"),
      path: "/email-marketing",
      icon: icon("mail.svg"),
    });
  }

  if (
    isBranch &&
    (access.includes(Access.RESTAURANT) ||
      access.includes(Access.OUTDOOR_ORDER) ||
      access.includes(Access.SALE) ||
      access.includes(Access.ORDER) ||
      access.includes(Access.INVOICE) ||
      access.includes(Access.QUOTATION)) &&
    (role === Role.SUPERADMIN || role === Role.ADMIN || role === Role.MANAGER)
  ) {
    navConfig.push({
      title: t("Printers"),
      path: "/printers",
      icon: icon("printer.svg"),
    });
  }

  return navConfig;
};

export default getNavConfig;
